import React from "react";
import { Link } from "react-router-dom";
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Container,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Input
} from "reactstrap";

import dashboardRoutes from "routes/dashboard.jsx";
import moment from "moment";
import "moment/locale/es";

const NOTIFICATIONS = "notifications";
const USER = "user";

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      dropdownOpen: false,
      notificationsOpen: false,
      color: "transparent"
    };

    moment.updateLocale("es", {
      relativeTime: {
        future: "en %s",
        past: "hace %s",
        s: "unos segundos",
        ss: "%d segundos",
        m: "un minuto",
        mm: "%d minutos",
        h: "una hora",
        hh: "%d horas",
        d: "un día",
        dd: "%d días",
        w: "una semana",
        ww: "%d semanas",
        M: "un mes",
        MM: "%d meses",
        y: "un año",
        yy: "%d años"
      }
    });

    this.toggle = this.toggle.bind(this);
    this.dropdownToggle = this.dropdownToggle.bind(this);
    this.getNotifications = this.getNotifications.bind(this);
    this.readNotification = this.readNotification.bind(this);
    this.unreadNotification = this.unreadNotification.bind(this);
    this.getMaxNotifications = this.getMaxNotifications.bind(this);

    // console.log("Header props", props);
  }
  toggle() {
    if (this.state.isOpen) {
      this.setState({
        color: "transparent"
      });
    } else {
      this.setState({
        color: "green"
      });
    }
    this.setState({
      isOpen: !this.state.isOpen
    });
  }
  dropdownToggle(toggle) {
    switch (toggle) {
      case USER:
        this.setState({
          dropdownOpen: !this.state.dropdownOpen
        });
        break;
      case NOTIFICATIONS:
        this.setState({
          notificationsOpen: !this.state.notificationsOpen
        });
        break;
      default:
        break;
    }
  }
  getBrand() {
    var name;
    dashboardRoutes.map((prop, key) => {
      if (prop.collapse) {
        prop.views.map((prop, key) => {
          if (prop.path === this.props.location.pathname) {
            name = prop.name;
            if (prop.path === "/rtl-support") {
              name = " وحة القيادة";
            }
          }
          return null;
        });
      } else {
        if (prop.redirect) {
          if (prop.path === this.props.location.pathname) {
            name = prop.name;
          }
        } else {
          if (prop.path === this.props.location.pathname) {
            name = prop.name;
          }
        }
      }
      return null;
    });
    return name;
  }
  openSidebar() {
    document.documentElement.classList.toggle("nav-open");
    this.refs.sidebarToggle.classList.toggle("toggled");
  }
  // function that adds color white/transparent to the navbar on resize (this is for the collapse)
  updateColor() {
    if (window.innerWidth < 993 && this.state.isOpen) {
      this.setState({
        color: "white"
      });
    } else {
      this.setState({
        color: "transparent"
      });
    }
  }
  componentDidMount() {
    window.addEventListener("resize", this.updateColor.bind(this));
  }
  componentDidUpdate(e) {
    if (
      window.innerWidth < 993 &&
      e.history.location.pathname !== e.location.pathname &&
      document.documentElement.className.indexOf("nav-open") !== -1
    ) {
      document.documentElement.classList.toggle("nav-open");
      this.refs.sidebarToggle.classList.toggle("toggled");
    }
  }
  createNotificationRedirect(redirect) {
    switch (redirect.type) {
      case "customer":
        return "/clientes/fichas/" + redirect.id;
      case "home_visit":
        return "/citas/" + redirect.id;
      case "register_box":
        return "/cajas/" + redirect.id;
      case "ticket":
        return "/tickets/" + redirect.id;
      case "contract":
        return "/contratos/" + redirect.id;
      default:
        return "#";
    }
  }
  getMaxNotifications() {
    if (!this.props.state.configuration) return 5;
    let result = 2;
    if (this.props.state.configuration && Object.keys(this.props.state.configuration).length > 0) {
      Object.keys(this.props.state.configuration).map(category => {
        // console.log("in loop category: ", category);
        category = this.props.state.configuration[category];
        // console.log("in loop category cleaned: ", category);
        if (category.tweaks && Object.keys(category.tweaks).length > 0) {
          Object.keys(category.tweaks).map(tweak => {
            tweak = category.tweaks[tweak];
            if(tweak.id === "notifications-number") result = parseInt(tweak.value);
          });
        }
      });
    }
    return result;
  }
  getNotifications() {
    let count = 0;
    let notifications = null;
    let maxNotificacions = this.getMaxNotifications();
    let showedNotifications = 0;
    let notifications_ids = [];
    let raw_notifications = this.props.state.notifications;

    if (raw_notifications && Object.keys(raw_notifications).length > 0)
      notifications_ids = Object.keys(raw_notifications).reverse();

    if (notifications_ids.length > 0) {
      notifications = [];
      // console.log("Ya tenemos notifications en getNotifications", raw_notifications);
      notifications_ids.map(current_id => {
        let current = raw_notifications[current_id];
        showedNotifications++;
        if (!current.isRead) count++;
        if (showedNotifications > maxNotificacions) return;
        let notification_type = <span className={"type " + current.type.name.toLowerCase()}></span>;
        let notification_category = current.category.map(category => {
          return <span key={category.id} className={"category " + category.id}>{category.name}</span>;
        });
        let notification_text = <div style={{display: "contents"}} dangerouslySetInnerHTML={{ __html: current.text_short }} />;
        let notification_state = current.isRead ? "read" : "unread";
        let date_class = "notification-date " + notification_state;
        let notification_date = <span className={date_class}>{moment(current.date).fromNow()}</span>;
        let notification_isForMe = null;
        if (current.isForMe)
          notification_isForMe = <span className="is-for-me">{"Para mí"}</span>;
        let notification = (
          <DropdownItem
            className={"notification " + notification_state}
            tag="a"
            onClick={() => {
              this.readNotification(current.id);
              if (current.hasRedirect) this.redirectTo(this.createNotificationRedirect(current.redirect));
            }}
            onContextMenu={e => {
              e.preventDefault();
              this.unreadNotification(current.id);
            }}
            key={current.id}
          >
            {notification_type}{notification_category}{notification_text}
            <br />
            {notification_date}{notification_isForMe}
          </DropdownItem>
        );
        notifications.push(notification);
      });
    }

    return {
      count: count,
      notifications: notifications
    };
  }
  readNotification(notification) {
    console.log("Read notification", notification);
    // console.log("this.props", this.props);
    this.props.read_notification(notification);
  }
  unreadNotification(notification) {
    console.log("Unread notification", notification);
    // console.log("this.props", this.props);
    this.props.unread_notification(notification);
  }
  redirectTo(redirect) {
    this.props.history.push(redirect);
  }
  render() {
    let notifications = this.getNotifications();
    // console.log("Ya tenemos notifications en render", notifications);
      
      let becariosUsers = [
        "Miguel.Zarzo-nadunet"
      ];
      let isBecario = false;
      if (becariosUsers.indexOf(this.props.mainState.user.name)  > -1) {
        isBecario = true;
      }
      let externalUsers = [
        "Oniti"
      ];
      let isExterno = false;
      if (externalUsers.indexOf(this.props.mainState.user.name)  > -1) {
        isExterno = true;
      }
    return (
      // add or remove classes depending if we are on full-screen-maps page or not
      <Navbar
        color={
          this.props.location.pathname.indexOf("full-screen-maps") !== -1
            ? "white"
            : this.state.color
        }
        expand="lg"
        className={
          this.props.location.pathname.indexOf("full-screen-maps") !== -1
            ? "navbar-absolute "
            : "navbar-absolute " +
              (this.state.color === "transparent" ? "navbar-transparent " : "")
        }
      >
        <Container fluid>
          <div className="navbar-wrapper">
            <div className="navbar-toggle">
              <button
                type="button"
                ref="sidebarToggle"
                className="navbar-toggler"
                onClick={() => this.openSidebar()}
              >
                <span className="navbar-toggler-bar bar1" />
                <span className="navbar-toggler-bar bar2" />
                <span className="navbar-toggler-bar bar3" />
              </button>
            </div>
            <NavbarBrand href="/">{this.getBrand()}</NavbarBrand>
          </div>
          {/* <NavbarToggler onClick={this.toggle}>
            <span className="navbar-toggler-bar navbar-kebab" />
            <span className="navbar-toggler-bar navbar-kebab" />
            <span className="navbar-toggler-bar navbar-kebab" />
          </NavbarToggler> */}
          <Collapse
            isOpen={this.state.isOpen}
            navbar
            className="justify-content-end"
          >
            {/* <form>
              <InputGroup className="no-border">
                <Input placeholder="Buscar..." />

                <InputGroupAddon addonType="append">
                  <InputGroupText>
                    <i className="now-ui-icons ui-1_zoom-bold" />
                  </InputGroupText>
                </InputGroupAddon>
              </InputGroup>
            </form> */}
            <Nav navbar>
              {/* <NavItem>
                <Link to="#pablo" className="nav-link">
                  <i className="now-ui-icons media-2_sound-wave" />
                  <p>
                    <span className="d-lg-none d-md-block">Actividad</span>
                  </p>
                </Link>
              </NavItem> */}
              {/* <NavItem>
                <Link to="#pablo" className="nav-link notifications">
                  <div id="notifications-bubble">
                    <span>3</span>
                  </div>
                  <i className="now-ui-icons design_bullet-list-67" />
                  <p>
                    <span className="d-lg-none d-md-block">Notificaciones</span>
                  </p>
                </Link>
              </NavItem> */}
              {/* <Dropdown
                nav
                isOpen={this.state.notificationsOpen}
                toggle={e => this.dropdownToggle(NOTIFICATIONS)}
              >
                <DropdownToggle caret nav>
                  {notifications.count > 0 && (
                    <div id="notifications-bubble">
                      <span>{notifications.count}</span>
                    </div>
                  )}
                  <i className="now-ui-icons design_bullet-list-67" />
                  <p>
                    <span className="d-lg-none d-md-block">Notificaciones</span>
                  </p>
                </DropdownToggle>
                <DropdownMenu right id="notifications-list">
                  {notifications.notifications}
                  {notifications.notifications === null && <DropdownItem className="notification"> No hay notificaciones </DropdownItem>}
                  {notifications.notifications !== null && <DropdownItem onClick={() => this.redirectTo("/notificaciones")} className="notification text-center view-all"> Ver todas </DropdownItem>}
                  {/* <Link to="/clientes/fichas/635">
                    <DropdownItem tag="a" onClick={() =>this.readNotification("test-notification")}>
                      <span className="type error"></span>
                      <span className="category">Móvil</span>Portabilidad denegada a <b>Adrián Duque</b> del número <b>601983888</b> por falta de correspondencia en el titular
                      <br />
                      <span className="notification-date unread">{moment("2021-01-20T12:07:01", "").fromNow()}</span>
                    </DropdownItem>
                  </Link>
                  <Link to="/clientes/fichas/635">
                    <DropdownItem tag="a" onClick={() =>this.readNotification("test-notification")}>
                      <span className="type ok"></span>
                      <span className="category">Móvil</span>Portabilidad aceptada a <b>Adrián Duque</b> del número <b>601983888</b> para el día <b>22/01/2021</b>
                      <br />
                      <span className="notification-date read">{moment("2021-01-20T12:07:01", "").fromNow()}</span>
                    </DropdownItem>
                  </Link>
                  <Link to="/clientes/fichas/635">
                    <DropdownItem tag="a" onClick={() =>this.readNotification("test-notification")}>
                      <span className="type warning"></span>
                      <span className="category">Móvil</span>Error al subir los documentos de la portabilidad de <b>Adrián Duque</b> del número <b>601983888</b>
                      <br />
                      <span className="notification-date unread">{moment("2021-01-20T12:07:01", "").fromNow()}</span>
                    </DropdownItem>
                  </Link>
                  <DropdownItem>Notificación 2</DropdownItem>
                  <DropdownItem>Notificación 3</DropdownItem>
                  <DropdownItem>Notificación 4</DropdownItem>
                  <DropdownItem>Notificación 5</DropdownItem>
                  <DropdownItem>Notificación 6</DropdownItem>
                  <DropdownItem>Notificación 7</DropdownItem>
                  <DropdownItem>Notificación 8</DropdownItem>
                  <DropdownItem className="notification" tag="a" onClick={() =>{this.readNotification("test-notification"); this.redirectTo("/clientes/fichas/635")}}>
                    <span className="type warning"></span>
                    <span className="category">Móvil</span>Error al subir los documentos de la portabilidad de <b>Adrián Duque</b> del número <b>601983888</b>
                    <br />
                    <span className="notification-date unread">{moment("2021-01-20T12:07:01", "").fromNow()}</span>
                  </DropdownItem>
                </DropdownMenu>
              </Dropdown> */}
              {/* <Dropdown
                nav
                isOpen={this.state.dropdownOpen}
                toggle={e => this.dropdownToggle(USER)}
                className="notifications-list"
              >
                <DropdownToggle caret nav>
                  <i className="now-ui-icons users_single-02" />
                  <p>
                    <span className="d-lg-none d-md-block">Mi cuenta</span>
                  </p>
                </DropdownToggle>
                <DropdownMenu right>
                  <DropdownItem className="notification" tag="a" onClick={(e)=>{this.redirectTo("/configuracion")}}>Configuración</DropdownItem>}
                  <DropdownItem className="notification" tag="a" onClick={(e)=>{this.props.signOut()}}>Cerrar sesión</DropdownItem>
                  <DropdownItem tag="a">Another Action</DropdownItem>
                  <DropdownItem tag="a">Something else here</DropdownItem>
                </DropdownMenu>
              </Dropdown> */}

              {/* <NavItem>
                <Link to="#pablo" className="nav-link">
                  <i className="now-ui-icons users_single-02" />
                  <p>
                    <span className="d-lg-none d-md-block">Account</span>
                  </p>
                </Link>
              </NavItem> */}
            </Nav>
          </Collapse>
        </Container>
      </Navbar>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/Header.jsx